import {AfterContentChecked, ChangeDetectorRef, Component, DoCheck, Input, KeyValueDiffers, OnInit} from '@angular/core';
import {DataSharingService} from '../services/data-sharing.service';
import {ApiService} from '../services/api.service';
// @ts-ignore
import {Index} from '../modals/Index';
import {LoaderService} from '../shared/loader/loader-service.services';
import {PagingModel} from '../shared/pagination-control/PagingModel';
import {ScreenerFilter} from '../modals/ScreenerFilter';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {Router} from '@angular/router';
import {UtilService} from '../services/UtilService';
import {Family} from '../modals/Family';
import {ColDef, GridReadyEvent} from 'ag-grid-community';
import {Store} from '@ngxs/store';
import {SavePageNumber, SaveStateName} from '../ngxs/screener-filter.action';
import {DownloadLinkModalComponent} from '../../download-link-modal/download-link-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-iboxx-screener-page',
  templateUrl: './iboxx-screener-page.component.html',
  styleUrls: ['./iboxx-screener-page.component.scss']
})
export class IboxxScreenerPageComponent implements OnInit, AfterContentChecked, DoCheck {

  @Input() indexType = 'all';
  alertMessage = 'Maximum 5 indices can be displayed';
  alertType = 'info';
  showAlert = false;
  domLayout = 'autoHeight';
  showTimeoutAlert = false;
  timeoutMessage = '';
  timeout: any = null;
  docStatus: boolean = false;

  tabList = [''];
  fileHeader = 'default';
  currentView = 'Indices';
  indexFamilyCol: ColDef[] = [
    {
      headerName: 'Family Name',
      width: 300,
      field: 'familyName',
      tooltipField: 'familyName',
      cellStyle: {color: '#53575C', fontWeight: 'bold'}
    },
    {
      headerName: 'Guide',
      width: 600,
      field: 'methodology',
      // @ts-ignore
      cellRenderer: (params: any) => {
        let value = '';
        this.shareService.s3Contents.forEach((content: any) => {
          if (content.familyName && content.familyName === params.data.familyName){
            value += '<div class="link">' + content.documentName.split('/')[content.documentName.split('/').length - 1] + '</div>';
          }
        });
        return value.length > 0 ? value : null;
      },
      onCellClicked: (param: any) => {
        this.fetchDocForFamily(param.event.target.innerText);
      }
    },
    // {
    //   headerName: '',
    //   minWidth: '110',
    //   maxWidth: '110',
    //   field: 'esgDisclosure',
    //   cellRenderer: (params: any) => {
    //     return params.value === null ? '' : '<span class="link">' + params.value + '</span>';
    //   },
    //   onCellClicked: (param: any) => {
    //     this.fetchDocForFamily(param.data.familyName, param.value);
    //   }
    // },
    // {
    //   headerName: '',
    //   minWidth: '110',
    //   maxWidth: '110',
    //   field: 'news',
    //   cellRenderer: (params: any) => {
    //     return params.value === null ? '' : '<span class="link">' + params.value + '</span>';
    //   },
    //   onCellClicked: (param: any) => {
    //     this.fetchDocForFamily(param.data.familyName, param.value);
    //   }
    // }
  ];

  indexFamilyRow: Family[] = [];

  indexGrid: any;
  indexFamilyGrid: any;
  columnDefs = [
    {
      headerName: 'Index Name', width: 300, maxWidth: 500, field: 'indexName',
      pinned: 'left', sortable: true,
      cellRenderer: (params: any) => {
        return params.data.indexName === null ? '' : '<span class="link">' + params.value + '</span>';
      },
      onCellClicked: (param: any) => {
        if (!param.data.isinTri) {
          this.getIndexDetailsFor(param.value + '?' + param.data.inflationAdjustment);
        }
      },
      comparator: ((valueA: string, valueB: string) => valueA.toUpperCase() < valueB.toUpperCase() ? -1 : 1)
    },
    {headerName: 'Region', width: 100, field: 'region', hide: true, tooltipField: 'region', sortable: true},
    {headerName: 'Index Family', width: 200, maxWidth: 500, field: 'indexFamily', tooltipField: 'indexFamily',
      hide: true, sortable: true},
    {headerName: 'ISIN', width: 110, field: 'isinTri', hide: true, sortable: true},
    {headerName: 'Bloomberg Ticker TRI', width: 80, field: 'bloombergTicker', hide: true, sortable: true},
    {headerName: 'As Of Date', width: 90, field: 'asOf', sortable: true, comparator: () => 0},
    {headerName: 'Fixing', width: 80, field: 'fixing', sortable: true, comparator: () => 0},
    {headerName: 'Inflation Adjustment', width: 80, headerTooltip: 'Inflation Adjustment',
      hide: true, field: 'inflationAdjustment', sortable: true},
    {headerName: 'TRI Level', width: 80, field: 'totalReturnIndex', sortable: true,
      comparator: () => 0},
    {headerName: 'Daily %', width: 80, field: 'dailyReturn', sortable: true,
      comparator: () => 0 },
    {headerName: 'MTD %', width: 80, field: 'monthToDateReturn', sortable: true,
      comparator: () => 0 },
    {headerName: 'QTD %', width: 80, field: 'quarterToDateReturn', sortable: true,
      comparator: () => 0 },
    {headerName: 'YTD %', width: 80, field: 'yearToDateReturn', sortable: true,
      comparator: () => 0 },
    {headerName: 'Annual Yield', width: 80, sortable: true, field: 'yield',
      comparator: () => 0 },
    {headerName: 'Duration', width: 80, sortable: true, field: 'duration',
      comparator: () => 0 },
    {headerName: 'No. of Constituents', headerTooltip: 'No. of Constituents', width: 80, field: 'bondsCount', sortable: true,
      comparator: () => 0 },
    {headerName: 'Currency', hide: true, width: 80, field: 'indexCurrency', sortable: true},
    {headerName: 'FX Version', hide: true, headerTooltip: 'Fx Version', width: 80, field: 'fxVersion', sortable: true},
    {headerName: 'Investment Type', hide: true, headerTooltip: 'Investment Type', width: 100,
      field: 'investmentType', sortable: true, tooltipField: 'investmentType'
    },
    {headerName: 'Sector', hide: true, width: 80, field: 'sector', tooltipField: 'sector', sortable: true},
    {
      headerName: 'Sub-sector', hide: true, headerTooltip: 'Sub-sector', width: 80,
      field: 'subSector', tooltipField: 'subSector', sortable: true
    },
    {headerName: 'Rating', hide: true, width: 80, field: 'rating', sortable: true},
    {headerName: 'Maturity', hide: true, width: 80, field: 'maturity', tooltipField: 'maturity', sortable: true},
  ];

  tooltipData: any;
  showTooltip = false;
  rowData: Index[] = [];
  pagingInfo: PagingModel = new PagingModel();
  dataLoaded = false;
  headlineIndices = false;
  headlineIndicesData: Index[] = [];
  // @ts-ignore
  screenerFilter: ScreenerFilter = new ScreenerFilter();
  dataFiltered = false;
  filteredResult: Index[] = [];
  maturityMapping = {
    '1-3 years': 'years1To3',
    '1-5 years': 'years1To5',
    '1-10 years': 'years1To10',
    '1-15 years': 'years1To15',
    '1-20 years': 'years1To20',
    '3-5 years': 'years3To5',
    '5-7 years': 'years5To7',
    '5-10 years': 'years5To10',
    '5-15 years': 'years5To15',
    '5 years plus': 'years5Plus',
    '7-10 years': 'years7To10',
    '7 years plus': 'years7Plus',
    '10-15 years': 'years10To15',
    '10 years plus': 'years10Plus',
    '15-20 years': 'years15To20',
    '15-25 years': 'years15To25',
    '15 years plus': 'years15Plus',
    '20-25 years': 'years20To25',
    '25-30 years': 'years25To30',
    '25 years plus': 'years25Plus',
    '30 years plus': 'years30Plus'
  };
  differ: any;


  constructor(private shareService: DataSharingService, private apiService: ApiService,
              private loader: LoaderService, private utilService: UtilService, private route: Router, private cdRef: ChangeDetectorRef,
              private differs: KeyValueDiffers, private store: Store, private modalService: NgbModal) {
    this.differ = this.differs.find({}).create();

    this.apiService.getDocStatus().subscribe((resp: any) => {
      this.docStatus = resp;
    });
  }

  ngOnInit(): void {
    // @ts-ignore
    const tabGroup = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) :
      {
        all: [],
        futures: [],
        trs: [],
        esg: [],
      };
    this.tabList = tabGroup[this.indexType].length > 0 ? tabGroup[this.indexType]
      : this.indexType === 'trs' ? ['screener', 'trs calculator', 'documentation']
        : ['screener', 'documentation'];
    this.loader.show();
    this.store.select(state => state.screenerPage.pageNumber).subscribe((resp: any) => {
      this.shareService.currentPage = this.indexType === 'all' ? resp : 0;
    });
    // this.getLocation();
    this.headlineIndices = true;
    this.store.select(state => state.screenerFilters.screenerFilters).subscribe((resp: any) => {
      const storedFilter = resp[this.indexType];
      if (!window.location.href.includes('EMIX')) {
        this.getHeadlineIndices();
        if (Object.keys(storedFilter).length > 0) {
          this.dataFiltered = true;
          // this.populateFilteredResult(this.shareService.filteredObject);
          this.applyFilter(storedFilter);
          this.showRow();
          this.loader.hide();
        }
      }
    });
    if (this.tabList.length === 1) {
      localStorage.clear();
    }

  }

  ngDoCheck(): void {
    const change = this.differ.diff(this.shareService.s3Contents);
    if (change) {
      this.populateIndexFamilyRow(this.headlineIndicesData);
    }
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  onGridReady(event: GridReadyEvent): void {
    this.indexGrid = event.api;
    this.changePage();
    this.showRow();
  }

  onMouseOver(event: any): void{
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (event.colDef.headerName === 'Index Name'){
        this.tooltipData = event;
        this.showTooltip = true;
      }
    }, 1000);
  }

  onSortChanged(event: any): void{
    const sortController = event.columnApi.getColumnState().find((col: any) => col.sort !== null);
    let tempCopy = this.dataFiltered ? JSON.parse(JSON.stringify(this.filteredResult)) : JSON.parse(JSON.stringify(this.rowData));
    if (sortController) {
      const blankRows = this.rowData.filter((data: any) => data[sortController.colId] === '');
      if (blankRows.length > 0){
        blankRows.forEach((row: any) => {
          const index = tempCopy.findIndex((temp: any) => temp.indexName === row.indexName &&
            temp.inflationAdjustment === row.inflationAdjustment);
          tempCopy.splice(index, 1);
        });
      }
      if (this.dataFiltered) {
        this.formatData(tempCopy);
      }
      tempCopy = this.sortDataBasedOn(tempCopy, sortController.colId, sortController.sort);
      if (sortController.sort === 'asc'){
        blankRows.forEach((row: any) => tempCopy.splice(0, 0, row));
      }else{
        blankRows.forEach((row: any) => tempCopy.push(row));
      }
      this.indexGrid.setRowData(tempCopy);
    }else{
      this.populateIndexData(this.dataFiltered ? this.filteredResult : this.headlineIndicesData);
    }
  }

  sortDataBasedOn(data: any, columnName: string, order: string): any{
    if (order === 'asc'){
      if (columnName === 'fixing'){
        return data.sort((d1: any, d2: any) => {
          if (d1[columnName].toUpperCase() === 'FE_EOD' || d2[columnName].toUpperCase() === 'FE_EOD'){
            return d1[columnName].toUpperCase() === 'FE_EOD' ? -1 : 1;
          }
          if (d1[columnName].toUpperCase() === 'EU_EOD' || d2[columnName].toUpperCase() === 'EU_EOD'){
            return d1[columnName].toUpperCase() === 'EU_EOD' ? -1 : 1;
          }
          if (d1[columnName].toUpperCase() === 'US_EOD' || d2[columnName].toUpperCase() === 'US_EOD'){
            return d1[columnName].toUpperCase() === 'US_EOD' ? -1 : 1;
          }
          return 0;
        });
      }
      if (columnName === 'asOf'){
        return data.sort((d1: any, d2: any) => new Date(d1[columnName]).getTime() < new Date(d2[columnName]).getTime() ? -1 : 1);
      }
      return data.sort((d1: any, d2: any) => parseFloat(d1[columnName]) < parseFloat(d2[columnName]) ? -1 : 1);
    }else{
      if (columnName === 'fixing'){
        return data.sort((d1: any, d2: any) => {
          if (d1[columnName].toUpperCase() === 'US_EOD' || d2[columnName].toUpperCase() === 'US_EOD'){
            return d1[columnName].toUpperCase() === 'US_EOD' ? -1 : 1;
          }
          if (d1[columnName].toUpperCase() === 'EU_EOD' || d2[columnName].toUpperCase() === 'EU_EOD'){
            return d1[columnName].toUpperCase() === 'EU_EOD' ? -1 : 1;
          }
          if (d1[columnName].toUpperCase() === 'FE_EOD' || d2[columnName].toUpperCase() === 'FE_EOD'){
            return d1[columnName].toUpperCase() === 'FE_EOD' ? -1 : 1;
          }
          return 0;
        });
      }
      if (columnName === 'asOf'){
        return data.sort((d1: any, d2: any) => new Date(d1[columnName]).getTime() > new Date(d2[columnName]).getTime() ? -1 : 1);
      }
      return data.sort((d1: any, d2: any) => parseFloat(d1[columnName]) < parseFloat(d2[columnName]) ? 1 : -1);
    }
  }

  formatData(data: any): any{
    data.forEach((res: any) => {
      res.asOf = this.utilService.formatDate(res.asOf);
      res.baseDate = this.utilService.formatDate(res.baseDate);
      res.fixing = res.fixing.toUpperCase();
      res.totalReturnIndex = res.totalReturnIndex ? parseFloat(res.totalReturnIndex).toFixed(4) : '';
      res.dailyReturn = res.dailyReturn ? (res.dailyReturn * 100).toFixed(4) : '';
      res.monthToDateReturn = res.monthToDateReturn ? (res.monthToDateReturn * 100).toFixed(4) : '';
      res.quarterToDateReturn = res.quarterToDateReturn ? (res.quarterToDateReturn * 100).toFixed(4) : '';
      res.yearToDateReturn = res.yearToDateReturn ? (res.yearToDateReturn * 100).toFixed(4) : '';
      if (res.indexAnalyticsBond) {
        res.yield = res.indexAnalyticsBond.annualYield ? parseFloat(res.indexAnalyticsBond.annualYield).toFixed(4) : '';
      } else {
        res.yield = res.indexAnalyticsLoan && res.indexAnalyticsLoan.currentYield ?
          parseFloat(res.indexAnalyticsLoan.currentYield).toFixed(4) : '';
      }
      res.duration = res.duration ? parseFloat(res.duration).toFixed(4) : '';
      res.bondsCount = res.numberOfInstruments;
      if (res.productRegion){
        res.region = res.productRegion === '(unassigned)' ? '' : res.productRegion.split(',').join(', ');
      }else {
        res.region = res.region === '(unassigned)' ? '' : res.region.split(',').join(', ');
      }
      res.indexCurrency = res.indexCurrency === '(unassigned)' ? '' : res.indexCurrency;
      res.fxVersion = res.fxVersion === '(unassigned)' ? '' : res.fxVersion;
      res.investmentType = res.investmentType === '(unassigned)' ? '' : res.investmentType.split(',').join(', ');
      res.sector = this.utilService.getSector(res);
      res.subSector = this.utilService.getSubSector(res);

      Object.keys(this.maturityMapping).forEach((key: string) => {
        // @ts-ignore
        if (res[this.maturityMapping[key]]) {
          res.maturity = key;
        }
      });
    });
  }

  closeTooltip(): void{
    this.showTooltip = false;
  }

  onIndexFamilyGridReady(event: any): void {
    this.indexFamilyGrid = event.api;
  }

  onGridSizeChanged(): void {
    this.utilService.agGridSizeColumnsToFit(this.indexFamilyGrid);
    this.utilService.agGridSizeColumnsToFit(this.indexGrid);
  }


  populateIndexData(result: any): void {
    this.rowData = [];
    this.dataLoaded = false;
    result.forEach((res: any) => {
      const idx: Index = new Index();
      idx.indexFamily = res.productName === '(unassigned)' ? '' : res.productName.split(',').join(', ');
      idx.indexName = res.indexName;
      idx.isinTri = res.isinTri;
      idx.bloombergTicker = res.bbgTickerTri;
      idx.asOf = this.utilService.formatDate(res.asOf);
      idx.baseDate = this.utilService.formatDate(res.baseDate);
      idx.fixing = res.fixing.toUpperCase();
      idx.inflationAdjustment = res.inflationAdjustment;
      idx.inflationLinked = res.inflationLinked;
      idx.totalReturnIndex = res.totalReturnIndex ? parseFloat(res.totalReturnIndex).toFixed(4) : '';
      idx.dailyReturn = res.dailyReturn ? (res.dailyReturn * 100).toFixed(4) : '';
      idx.monthToDateReturn = res.monthToDateReturn ? (res.monthToDateReturn * 100).toFixed(4) : '';
      idx.quarterToDateReturn = res.quarterToDateReturn ? (res.quarterToDateReturn * 100).toFixed(4) : '';
      idx.yearToDateReturn = res.yearToDateReturn ? (res.yearToDateReturn * 100).toFixed(4) : '';
      if (res.indexAnalyticsBond) {
        idx.yield = res.indexAnalyticsBond.annualYield ? parseFloat(res.indexAnalyticsBond.annualYield).toFixed(4) : '';
      } else {
        idx.yield = res.indexAnalyticsLoan && res.indexAnalyticsLoan.currentYield ?
          parseFloat(res.indexAnalyticsLoan.currentYield).toFixed(4) : '';
      }
      idx.duration = res.duration ? parseFloat(res.duration).toFixed(4) : '';
      idx.bondsCount = res.numberOfInstruments;
      idx.region = res.productRegion === '(unassigned)' ? '' : res.productRegion.split(',').join(', ');
      idx.indexCurrency = res.indexCurrency === '(unassigned)' ? '' : res.indexCurrency;
      idx.fxVersion = res.fxVersion === '(unassigned)' ? '' : res.fxVersion;
      idx.investmentType = res.investmentType === '(unassigned)' ? '' : res.investmentType.split(',').join(', ');
      idx.rating = res.rating;
      idx.redId = res.redId;
      idx.ratingCategory = res.ratingCategory;
      idx.sector = this.utilService.getSector(res);
      idx.subSector = this.utilService.getSubSector(res);

      Object.keys(this.maturityMapping).forEach((key: string) => {
        // @ts-ignore
        if (res[this.maturityMapping[key]]) {
          idx.maturity = key;
        }
      });

      this.rowData.push(idx);
    });
    this.displayInflationAdjustmentField();
    this.dataLoaded = true;
    // this.changePage();
  }

  populateIndexFamilyRow(batchData: any): void {
    this.indexFamilyRow = [];
    const familyNames: any = [];
    batchData.forEach((batch: any) => {
      if (batch.productName.split(',').length > 1) {
        familyNames.push.apply(familyNames, batch.productName.split(','));
      } else {
        familyNames.push(batch.productName);
      }
    });
    const uniqueFamilyName = [...new Set(familyNames)];
    uniqueFamilyName.forEach((familyName: any) => {
      if (familyName && familyName !== '(unassigned)') {
        const family: Family = new Family();
        family.familyName = familyName;
        family.esgDisclosure = 'ESG Disclosure';
        family.factSheet = 'Fact Sheet';
        family.methodology = 'Guide';
        family.news = 'News';
        const docs = this.shareService.s3Contents
          .map((content: any) => content.familyName)
          .filter((famName: string) => famName === familyName).length;
        // @ts-ignore
        family.rowHeight = docs === 0 ? 30 : 30 * docs;
        this.indexFamilyRow.push(family);
      }
    });
    this.indexFamilyRow.sort((row1: any, row2: any) => row1.familyName < row2.familyName ? -1 : 1);
    this.shareService.fetchedIndexFamily = this.indexFamilyRow;
  }

  getFamilyGridHeight(): number {
    // @ts-ignore
    const rowCount = this.indexFamilyRow.reduce((sum: number, current: Family) => sum + current.rowHeight, 0) / 30;
    return rowCount === 0 ? 0 : 70 + ((rowCount - 1) * 30);
  }

  getRowHeight(params: any): any {
    return params.data.rowHeight;
  }

  getDocumentConfigFromSFTP(): void {
    // this.documentConfig = window.location.href.includes('local') ? this.utilService.mockData : this.shareService.s3Contents;
    // this.apiService.getDocumentDetails('').subscribe((resp: any) => {
    //   this.documentConfig = resp[0];
    //   this.shareService.documentConfig = resp[0];
    // });
  }

  getHeadlineIndices(): void {
    this.headlineIndices = true;
    this.headlineIndicesData = [];
    this.headlineIndicesData = this.sortHeadlineIndices(this.shareService.headlineIndices
      .filter((index: any) => index.inflationAdjustment === 'Nominal'));
    switch (this.indexType) {
      case 'futures':
        this.headlineIndicesData = this.headlineIndicesData.filter((index: any) => index.investmentType.includes('Futures'));
        break;
      case 'trs':
        this.headlineIndicesData = this.headlineIndicesData.filter((index: any) => index.investmentType.includes('Standardized_TRS'));
        break;
      case 'esg':
        this.headlineIndicesData = this.headlineIndicesData.filter((index: any) => index.investmentType.includes('ESG_Sustainable'));
        break;
    }
    this.initPaging();
    this.populateIndexData(this.headlineIndicesData);
    // this.paginateFilteredData();
    this.shareScreenerFilters(this.headlineIndicesData);
    this.populateIndexFamilyRow(this.headlineIndicesData);
    this.loader.hide();

    // this.apiService.getHeadlineIndices('').subscribe((resp: any) => {
    //   this.headlineIndicesData = this.sortHeadlineIndices(resp.headlineIndices);
    //   this.shareService.headlineIndices = this.headlineIndicesData;
    //   this.shareService.headlineIDs = resp.headlineIDs;
    //   this.initPaging();
    //   this.paginateFilteredData();
    //   this.batchData = this.headlineIndicesData;
    //   this.shareScreenerFilters(this.headlineIndicesData);
    //   this.populateIndexFamilyRow(this.headlineIndicesData);
    //   this.shareService.completeBatchData = this.batchData;
    //   this.loader.hide();
    // });
  }

  sortHeadlineIndices(headlineIndices: any): any {
    headlineIndices.map((index: any) => {
      index.productRegion = null === index.productRegion ? '' : index.productRegion;
    });
    headlineIndices.map((index: any) => {
      index.productName = null === index.productName ? '' : index.productName;
    });
    headlineIndices.sort((ind1: any, ind2: any) => ind1.productRegion < ind2.productRegion ? -1 : 1);

    const uniqueRegion = [...new Set(headlineIndices.map((item: any) => item.productRegion))];
    let regionGroup: any = [];
    const groupedByRegion: any = [];
    const blankRegion: any = [];
    uniqueRegion.forEach((region: any) => {
      regionGroup = headlineIndices.filter((index: any) => index.productRegion === region);
      regionGroup.sort((ind1: any, ind2: any) => ind1.productName < ind2.productName ? -1 : 1);

      const uniqueFamilyName = [...new Set(regionGroup.map((item: any) => item.productName))];
      let familyGroup: any = [];
      const groupedByFamilyPerRegion: any = [];
      uniqueFamilyName.forEach((family: any) => {
        familyGroup = regionGroup.filter((index: any) => index.productName === family);
        familyGroup.sort((ind1: any, ind2: any) => ind1.numberOfInstruments > ind2.numberOfInstruments ? -1 : 1);

        const uniqueIndexName = [...new Set(familyGroup.map((item: any) => item.indexName))];
        let indexNameGroup: any = [];
        const groupedByIndexNamePerFamily: any = [];
        uniqueIndexName.forEach((index: any) => {
          indexNameGroup = familyGroup.filter((fam: any) => fam.indexName === index);
          indexNameGroup.sort((ind1: any, ind2: any) => ind1.inflationAdjustment > ind2.inflationAdjustment ? -1 : 1);
          groupedByIndexNamePerFamily.push.apply(groupedByIndexNamePerFamily, indexNameGroup);
        });

        groupedByFamilyPerRegion.push.apply(groupedByFamilyPerRegion, groupedByIndexNamePerFamily);
      });
      regionGroup.splice(0);
      if (region === '') {
        blankRegion.push.apply(blankRegion, groupedByFamilyPerRegion);
      } else {
        regionGroup.push.apply(regionGroup, groupedByFamilyPerRegion);
      }
      groupedByRegion.push.apply(groupedByRegion, regionGroup);
    });
    headlineIndices.splice(0);
    headlineIndices.push.apply(headlineIndices, groupedByRegion);
    headlineIndices.push.apply(headlineIndices, blankRegion);
    return headlineIndices;
  }

  getIndicesFromN6(page: number, pageSize: number): void {
    this.apiService.getAllIndices(page, pageSize).subscribe((resp: any) => {
      console.log(resp);
      if (resp.error) {
        this.showTimeoutAlert = true;
        this.timeoutMessage = resp.errorMessage;
      } else {
        this.initPaging();
        this.populateIndexData(resp.currentPageData);
        this.shareScreenerFilters(resp.currentBatchData);
        this.populateIndexFamilyRow(resp.currentBatchData);
        // this.shareService.completeBatchData = resp.currentBatchData;
      }
      this.loader.hide();
    });
  }

  shareScreenerFilters(batchData: any): void {
    this.screenerFilter.indexCurrency = batchData.map((batch: any) => {
      return batch.indexCurrency;
    })
      .filter((elem: string, index: number, self: string) => {
        return index === self.indexOf(elem);
      });

    this.screenerFilter.fxVersion = batchData.map((batch: any) => {
      return batch.fxVersion;
    })
      .filter((elem: string, index: number, self: string) => {
        return index === self.indexOf(elem) && isNotNullOrUndefined(elem);
      });

    const regions: string[] = [];
    const investmentTypes: string[] = [];
    const familyNames: string[] = [];
    batchData.forEach((batch: any) => {
      if (batch.productName.split(',').length > 1) {
        familyNames.push.apply(familyNames, batch.productName.split(','));
      } else {
        familyNames.push(batch.productName);
      }
      if (batch.investmentType.split(',').length > 1) {
        investmentTypes.push.apply(investmentTypes, batch.investmentType.split(','));
      } else {
        investmentTypes.push(batch.investmentType);
      }
      if (batch.productRegion.split(',').length > 1) {
        regions.push.apply(regions, batch.productRegion.split(','));
      } else {
        regions.push(batch.productRegion);
      }
    });
    this.screenerFilter.indexFamily = [...new Set(familyNames)];
    this.screenerFilter.region = [...new Set(regions)];

    const order = ['(unassigned)', 'Liquid', 'Broad', 'ESG_Sustainable', 'Standardized_TRS', 'Futures', 'ETFs_FUNDs', 'Smart_Beta_Strategy', 'Short'];
    // @ts-ignore
    this.screenerFilter.investmentType = [...new Set(investmentTypes)].sort((a: string, b: string) => order.indexOf(a) - order.indexOf(b));

    if (!this.shareService.filterApplied) {
    }
    this.shareService.currencyFilter = this.screenerFilter.indexCurrency;
    this.shareService.fxVersionFilter = this.screenerFilter.fxVersion;

    this.shareService.filters.next(this.screenerFilter);
    this.shareService.filteredBatchData.next(batchData);
    if (!this.dataFiltered) {
      this.shareService.currentBatchData.next(batchData);
    }

  }

  getIndexDetailsFor(indexName: string): void {
    const index = this.sortHeadlineIndices(this.shareService.headlineIndices).find((data: any) => {
      if (data.indexName === indexName.split('?')[0] && data.inflationAdjustment === indexName.split('?')[1]) {
        return data;
      }
    });

    if (!this.tabList.includes(indexName)) {
      if (this.tabList.length < 7) {
        this.tabList.push(indexName);
        // this.shareService.openedTabList.push(indexName);
      } else {
        window.scrollTo(0, 0);
        this.showAlert = true;
        this.deselectRow();
      }
    }
    if (this.tabList.includes(indexName)) {
      this.openIndexDetailsTab(index);
    }
  }

  onRowSelected(): void {
    const selectedNodes = this.indexGrid.getSelectedNodes();
    const selectedData = selectedNodes.find((node: any) => node.isSelected()).data;
    this.getIndexDetailsFor(selectedData.indexName + '?' + selectedData.inflationAdjustment);
  }

  deselectRow(): void {
    const selectedNodes = this.indexGrid.getSelectedNodes();
    const currentNode = selectedNodes.find((node: any) => node.isSelected());
    currentNode.selected = false;
    while (document.getElementsByClassName('ag-row-selected').length > 0) {
      const rows = document.getElementsByClassName('ag-row-selected');
      rows[0].classList.remove('ag-row-selected');
    }
  }

  openTab(event: any): void {
    if (event === 'documentation'){
      switch (this.indexType) {
        case 'all':
          this.route.navigateByUrl('Indices/docs/page?docFor=iBoxx');
          break;
        case 'futures':
          this.route.navigateByUrl('Futures/docs/page?docFor=iBoxx');
          break;
        case 'trs':
          this.route.navigateByUrl('TRS/docs/page?docFor=iBoxx');
          break;
        case 'esg':
          this.route.navigateByUrl('ESG/docs/page?docFor=iBoxx');
          break;
      }
    }else if (event === 'trs calculator'){
      this.route.navigateByUrl('iBoxx/TRS/Calculator');
    }else if (event !== 'screener') {
      this.getIndexDetailsFor(event);
    }
  }

  openIndexDetailsTab(index: any): void {
    this.shareService.currentTab = index.indexName + '?' + index.inflationAdjustment;
    this.shareService.tabList.next(this.tabList);
    this.utilService.saveTabListFor(this.indexType, this.tabList);
    this.store.dispatch(new SaveStateName(this.indexType));
    this.route.navigateByUrl('iBoxx/details/index?id=' + index.id);
  }

  applyFilter(event: any): void {
    this.dataFiltered = false;
    Object.keys(event).forEach((key: string) => {
      this.shareService.filteredMap.set(key, event[key]);
    });
    this.dataFiltered = true;
    this.shareService.filterApplied = true;
    // this.shareService.currentPage = this.pagingInfo.page;
    if (this.indexType === 'all') {
      this.store.dispatch(new SavePageNumber(this.pagingInfo.page));
    }
    let result = this.sortHeadlineIndices(this.shareService.headlineIndices);
    switch (this.indexType) {
      case 'futures':
        result = this.sortHeadlineIndices(this.shareService.headlineIndices.
        filter((index: any) => index.investmentType.includes('Futures')));
        break;
      case 'trs':
        result = this.sortHeadlineIndices(this.shareService.headlineIndices.filter((index: any) => index.investmentType.includes('Standardized_TRS')));
        break;
      case 'esg':
        result = this.sortHeadlineIndices(this.shareService.headlineIndices.filter((index: any) => index.investmentType.includes('ESG_Sustainable')));
        break;
    }
    Object.keys(event).forEach((key: string) => {
      if (this.currentView === 'Indices') {
        this.showRow();
      }
      if (key === 'maturity') {
        result = this.utilService.getRecordsForMaturity(event[key], result);
      } else if (key === 'sector') {
        result = this.utilService.getRecordsForSector(event[key], result);
      } else if (key === 'subSector') {
        result = this.utilService.getRecordsForSubSector(event[key], result);
      } else if (key === 'rating') {
        result = this.utilService.getRecordsForRating(event[key], result);
      } else if (key === 'investmentType') {
        result = this.utilService.getRecordsForInvestmentType(event[key], result);
      } else if (key === 'indexFamily') {
        result = this.utilService.getRecordsForIndexFamily(event[key], result);
      } else if (key === 'region') {
        result = this.utilService.getRecordsForRegion(event[key], result);
      } else if (key === 'indexCurrency') {
        result = this.utilService.getRecordsForIndexCurrency(event[key], result);
      } else if (key === 'fxVersion') {
        result = this.utilService.getRecordsForBaseCurrency(event[key], result);
      } else {
        result = result.filter((data: any) => {
          if (event[key].split('~').includes(data[key])) {
            return data;
          }
        });
      }
    });
    // TO TRIM REAL INLFATION ADJUSTMENT INDICES UNLESS INFLATION LINKED FAMILY IS FILTERED
    result = result === this.sortHeadlineIndices(this.shareService.headlineIndices) ? this.headlineIndicesData : result;
    if (result.findIndex((res: any) => !res.inflationLinked) >= 0){
      result = result.filter((res: any) => res.inflationAdjustment === 'Nominal');
    }
    this.shareService.filteredObject = result;
    this.filteredResult = result;
    this.shareService.filteredBatchData.next(result);
    this.populateFilteredResult(result);
  }

  clearFilter(): void {
    if (this.currentView === 'Indices') {
      this.showRow();
    }
    this.shareService.filterApplied = false;
    this.dataFiltered = false;
    // this.shareService.currentPage = 0;
    this.store.dispatch(new SavePageNumber(0));
    this.ngOnInit();
    this.changePage();
    this.utilService.agGridSizeColumnsToFit(this.indexGrid);
  }

  fetchDocForFamily(docName: string): void {
    const URL = this.apiService.createGetPath('/search/fileFromBucket',
      ['fileName',
    // @ts-ignore
        encodeURIComponent(this.shareService.s3Contents.find((content: any) => content.documentName.includes(docName)).documentName),
        'env']);
    window.open(URL);
    const modalRef = this.modalService.open(DownloadLinkModalComponent, {size: 'xl'});
    const documentInfo = {};
    // @ts-ignore
    documentInfo[docName] = URL;
    modalRef.componentInstance.documentInfo = documentInfo;
  }

  openGuideAsPDF(): void {
    this.loader.show();
    const fileName = 'CA003_Markit_Index_Standard_Treatment.pdf';
    this.apiService.getFileAsPDF('', fileName).subscribe((resp: any) => {
      this.loader.hide();
      const file = new Blob([resp], {type: 'application/pdf'});
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_newtab');
    });
  }

//  PAGINATION CONTROL

  changePage(): void {
    this.showTooltip = false;
    this.indexGrid.paginationGoToPage(this.pagingInfo.page);
    this.indexGrid.paginationSetPageSize(this.pagingInfo.pageSize);
    // this.shareService.currentPage = this.pagingInfo.page;
    if (this.indexType === 'all') {
      this.store.dispatch(new SavePageNumber(this.pagingInfo.page));
    }
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
    // if (this.shareService.filterApplied || this.headlineIndices) {
    //   this.paginateFilteredData();
    //   this.updatePaging();
    // } else {
    //   this.loader.show();
    //   this.dataLoaded = false;  // USED TO RE-INITIATE THE SCREENER FILTER
    //   this.apiService.getAllIndices((this.pagingInfo.page + 1), this.pagingInfo.pageSize)
    //     .subscribe((resp: any) => {
    //       this.populateIndexData(resp.currentPageData);
    //       this.shareScreenerFilters(resp.currentBatchData);
    //       this.populateIndexFamilyRow(resp.currentBatchData);
    //       this.shareService.completeBatchData = resp.currentBatchData;
    //       this.updatePaging();
    //       this.loader.hide();
    //     });
    // }
  }

  updateTableForFilteredResult(): void {
    this.pagingInfo.totalRows = this.filteredResult ? this.filteredResult.length : 0;
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
    this.pagingInfo.page = this.shareService.filterApplied && this.indexType === 'all'
    && this.pagingInfo.totalPages > this.shareService.currentPage ? this.shareService.currentPage : 0;
    // this.paginateFilteredData();
    this.populateIndexData(this.filteredResult);
  }

  paginateFilteredData(): void {
    const start = this.pagingInfo.pageSize * this.pagingInfo.page;
    this.shareService.currentPage = this.pagingInfo.page;
    if (this.headlineIndices) {
      if (this.dataFiltered) {
        this.populateIndexData(this.filteredResult.slice(start, (this.pagingInfo.pageSize + start)));
      } else {
        this.populateIndexData(this.headlineIndicesData.slice(start, (this.pagingInfo.pageSize + start)));
      }
    } else {
      this.populateIndexData(this.filteredResult.slice(start, (this.pagingInfo.pageSize + start)));
    }
  }

  initPaging(): void {
    this.pagingInfo.totalRows = this.headlineIndices ? this.headlineIndicesData.length : 100;
    this.pagingInfo.pageSize = 15;
    this.pagingInfo.visibleRows = 15;
    this.pagingInfo.page = this.shareService.currentPage;
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
  }

  updatePaging(): void {
    let recordSize = 100;
    if (this.headlineIndices) {
      if (this.shareService.filterApplied) {
        recordSize = this.filteredResult.length;
      } else {
        recordSize = this.headlineIndicesData.length;
      }
    }
    const rows = ((this.pagingInfo.page + 1) * this.pagingInfo.pageSize) / recordSize;
    if (this.headlineIndices) {
      this.pagingInfo.totalRows = recordSize;
    } else {
      this.pagingInfo.totalRows = Math.ceil(rows) !== rows ? Math.ceil(rows) * recordSize : (rows + 1) * recordSize;
    }
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
  }

  isLastPage(): boolean {
    return this.pagingInfo.totalPages === (this.pagingInfo.page + 1);
  }

  changeHeader(event: any): void {
    const definition = this.indexGrid.getColumnDefs();
    this.fileHeader = event;

    if (event === 'ftp') {
      definition.forEach((column: any) => {
        if (column.field === 'isinTri') {
          column.headerName = 'ISIN_TRi';
        }

        if (column.field === 'asOf') {
          column.headerName = 'Date';
        }

        if (column.field === 'bloombergTicker') {
          column.headerName = 'BBG_Ticker_TRi';
          column.headerTooltip = 'BBG_Ticker_TRi';
        }

        if (column.field === 'totalReturnIndex') {
          column.headerName = 'TRi_Today';
        }

        if (column.field === 'bondsCount') {
          column.headerName = 'Number of Constituents';
          column.headerTooltip = 'Number of Constituents';
        }
        if (column.field === 'indexCurrency') {
          column.headerName = 'Index Currency';
          column.headerTooltip = 'Index Currency';
        }

        if (column.field === 'rating') {
          column.headerName = 'Markit iBoxx Rating';
          column.headerTooltip = 'Markit iBoxx Rating';
        }
      });
    } else {
      definition.forEach((column: any) => {
        if (column.field === 'isinTri') {
          column.headerName = 'ISIN';
        }

        if (column.field === 'asOf') {
          column.headerName = 'As Of Date';
        }

        if (column.field === 'bloombergTicker') {
          column.headerName = 'Bloomberg Ticker TRI';
          column.headerTooltip = 'Bloomberg Ticker TRI';
        }

        if (column.field === 'totalReturnIndex') {
          column.headerName = 'TRI Level';
        }

        if (column.field === 'bondsCount') {
          column.headerName = 'No. of Constituents';
          column.headerTooltip = 'No. of Constituents';
        }
        if (column.field === 'indexCurrency') {
          column.headerName = 'Currency';
          column.headerTooltip = '';
        }

        if (column.field === 'rating') {
          column.headerName = 'Rating';
          column.headerTooltip = '';
        }
      });
    }
    this.columnDefs = definition;
  }

  closeAlert(): void {
    this.showAlert = false;
    this.showTimeoutAlert = false;
  }

  populateFilteredResult(result: any): void {
    this.filteredResult = result;
    this.updateTableForFilteredResult();
    this.populateIndexFamilyRow(result);
  }

  showRow(): void {
    const hiddenRows = ['sector', 'maturity', 'rating', 'investmentType', 'subSector', 'indexCurrency', 'fxVersion'];
    let definition = this.columnDefs;
    if (this.indexGrid) {
      definition = this.indexGrid.getColumnDefs();
    }
    if (definition) {
      definition.forEach((column: any) => {
        hiddenRows.forEach((row: string) => {
          if (column.field === row) {
            if (this.shareService.filteredMap.has(row)) {
              column.hide = false;
            } else {
              column.hide = true;
            }
          }
        });
      });
      this.columnDefs = definition;
    }
  }

  displayInflationAdjustmentField(): void{
    const definition = this.columnDefs;
    definition.forEach((column: any) => {
      if (column.field === 'inflationAdjustment'){
        if (this.dataFiltered) {
          column.hide = this.filteredResult.findIndex((data: any) => !data.inflationLinked) >= 0;
        }else {
          column.hide = this.headlineIndicesData.findIndex((data: any) => !data.inflationLinked) >= 0;
        }
      }
    });
    this.columnDefs = definition;
  }
}
